import PlayerCardCondensed from "@/design-system/PlayerCard/PlayerCardCondensed";
import {
  PlayerFacts,
  useCrestFacts,
} from "@/pages/Sbcs/components/PlayerFacts";
import { SWAP_CARD_SCALE } from "@/pages/Sbcs/components/PlayerSwapPopover";
import { StreamlinePlayerOption } from "@repo/shared/types";

/**
 * The Streamlined SBC solution's player facts. Its cards carry ids rather than
 * names, so the crests are resolved from the loaded-content store.
 */
export const StreamlinePlayerFacts = ({
  player,
  position,
  source,
  untradeable,
}: Pick<
  StreamlinePlayerOption,
  "player" | "position" | "source" | "untradeable"
>) => {
  const facts = useCrestFacts({
    clubId: player.clubId,
    leagueId: player.leagueId,
    countryId: player.countryId,
  });

  return (
    <PlayerFacts
      /* The backend's `name` is the common name, else first and last. */
      searchName={player.name}
      source={source}
      card={
        <PlayerCardCondensed
          player={player}
          position={position}
          scale={SWAP_CARD_SCALE}
          priceSize="small"
          untradeable={untradeable}
        />
      }
      facts={facts}
    />
  );
};
